(function() {
    'use strict';
    /**
     * @memberof wbDashboard
     * @ngdoc Services
     * @name Notification
     * @description Notification service to handle notification data
     */
    angular.module('wbDashboard').factory('NotificationBase', ['Request', '$q', '$timeout', 'User', function (Request, $q, $timeout, User) {
        var notificationBase;

        /**
         * @param {Object} options
         * @param {string} options.data
         */
        notificationBase = function(options) {

            options || (options = {}); // jshint ignore:line

            var notifications = {
                inline: {
                    server: [],
                    manual: [],
                    all: []
                }, //for server inline notifications
                modalList: [], //for modal notifications
                currentIndex: 0,
                prevIndex: -1,
                initialTotal: 0,
                unreadCount: 0,
                viewedAll: false,
                modal: false,
                sending: false,
                removing: false,
                loadPromise: $q.defer(),
                test: false
            };

            notifications.load = function () {
                return Request.make("user_notifications", options.data).then(function (response) {
                    var n;
                    notifications.currentIndex = 0;
                    notifications.modal = false;

                    notifications.inline.server = response.data.response.notifications;
                    // notifications.inline.server = notifications.inline.server.slice(1,2);
                    for (var i = notifications.inline.server.length - 1; i >= 0; i--) {
                        /* jshint loopfunc: true */

                        n = notifications.inline.server[i];

                        if (n.link.includes("?")) {
                            var split = n.link.split("?");
                            n.link = split[0];
                            n.params = JSON.parse('{"' + decodeURI(split[1].replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}');

                            angular.forEach(n.params, function(value, key) {
                                switch (key) {
                                    case 'milestone_id':
                                        n.params.msId = value;
                                        break;
                                    case 'survey_id':
                                        n.params.slugOrId = value;
                                        break;
                                    case 'recommendation_slug':
                                        n.params.slugOrId = value;
                                        break;
                                }
                            });

                        }
                        if (n.link.indexOf('modal') === 0) {
                            //entirely separate non-inline notifications and treat them uniquely
                            notifications.addModal(n);
                            notifications.inline.server.splice(i, 1);
                        } else {
                            n.type = "server";
                            n.viewed = false;
                            if (!n.read)
                                notifications.unreadCount++;
                        }
                    }

                    notifications.setInline();

                    if (notifications.modalList.length) {
                        notifications.modal = notifications.modalList[0];
                    }

                    notifications.initialTotal = notifications.inline.server.length;


                    notifications.loadPromise.resolve();

                    return notifications.inline.server;

                }).catch(function () {
                    if (notifications.test) {
                        notifications.loadPromise.resolve();
                        notifications.inline.server = [
                            {
                                "name": "invite link",
                                "id": "1",
                                "description": "you should invite some friends or something",
                                "read": false,
                                "link": 'invite',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "funding",
                                "id": "2",
                                "description": "fund things",
                                "read": false,
                                "link": 'funding',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "deposit",
                                "id": "3",
                                "description": "test description",
                                "read": false,
                                "link": 'funding_deposit',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "withdrawal",
                                "id": "4",
                                "description": "test description",
                                "read": false,
                                "link": 'funding_withdrawal',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "retirement milestone",
                                "id": "4.5a",
                                "description": "test description",
                                "read": false,
                                "link": 'milestone_retirement',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "rainy milestone",
                                "id": "4.5b",
                                "description": "test description",
                                "read": false,
                                "link": 'milestone_rainy_day',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "build wealth milestone",
                                "id": "4.5c",
                                "description": "test description",
                                "read": false,
                                "link": 'milestone_build_wealth',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "create retirement milestone",
                                "id": "5a",
                                "description": "test description",
                                "read": false,
                                "link": 'create_retirement',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "create rainy day milestone",
                                "id": "5b",
                                "description": "test description",
                                "read": false,
                                "link": 'create_rainy_day',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "create build wealth milestone",
                                "id": "5c",
                                "description": "test description",
                                "read": false,
                                "link": 'create_build_wealth',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "create build wealth milestone",
                                "id": "5d",
                                "description": "test description",
                                "read": false,
                                "link": 'create_custom',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "financial profile",
                                "id": "6",
                                "description": "test description",
                                "read": false,
                                "link": 'financial_profile',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "services",
                                "id": "7",
                                "description": "test description",
                                "read": false,
                                "link": 'services',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "documents",
                                "id": "8",
                                "description": "test description",
                                "read": false,
                                "link": 'documents',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                            {
                                "name": "personal",
                                "id": "9",
                                "description": "test description",
                                "read": false,
                                "link": 'personal',
                                "referrer_id": null,
                                "payload": "test message payload",
                                "timestamp": "2016-12-16T19:44:16+0000"
                            },
                        ];
                        return notifications.inline.server;
                    } else {
                        //nothing
                    }
                }).finally(function () {

                });
            };

            /**
             * Combines server inline and manual inline notifications
             */
            notifications.setInline = function() {
                notifications.inline.all = [].concat(notifications.inline.manual).concat(notifications.inline.server);
                var read = 0;
                notifications.inline.all.forEach(function(n) {
                    if (!n.read) {
                        read++;
                    }
                });
                notifications.unreadCount = read;

            };

            notifications.get = function (id) {
                if (id) {
                    var notice;
                    notice = notifications.inline.all.filter(function (value) {
                        return value.id === id;
                    });
                    if (!notice.length) {
                        notice = notifications.modalList.filter(function (value) {
                            return value.id === id;
                        });
                    }

                    if (notice.length) {
                        return notice[0];
                    } else {
                        return {};
                    }
                } else {
                    return notifications.inline.all;
                }
            };

            notifications.getCurrent = function() {
                return notifications.inline.all[notifications.currentIndex];
            };

            notifications.clearManual = function() {
                //want to shift the index to stay where it is after clearing manual
                if (notifications.currentIndex > notifications.inline.manual.length-1) {
                    notifications.currentIndex -= notifications.inline.manual.length;
                } else {
                    notifications.currentIndex = 0;
                    notifications.prevIndex = -1;
                }
                notifications.inline.manual.length = 0;
                notifications.setInline();
            };

            /**
             *
             * @param {Object} notice
             * @param {string} notice.id
             * @param {string} notice.name
             * @param {string} notice.description
             * @param {string} notice.ctaButton
             * @param {string} notice.link
             * @param {string} notice.skipButton
             */
            notifications.addManual = function(notice) {
                notice.type = 'manual';
                notice.viewed = false;
                notice.read = false;
                if (notifications.get(notice.id).id !== notice.id) {
                    notifications.inline.manual.unshift(notice);
                    notifications.setInline();

                    notifications.resetView('manual');
                }
            };
            notifications.addModal = function(notice) {
                notice.class = notice.link.replace(/[:_]/g, "-");
                notice.type = 'modal';
                notifications.modalList.unshift(notice);
            };
            notifications.addModalActive = function(notice) {
                notifications.addModal(notice);
                notifications.modal = notice;
            };

            notifications.linkData = [
                {
                    link: "overview",
                    path: "base.overview"
                },
                {
                    link: "invite",
                    path: "base.invite",
                    text: "Invite Friends!"
                },
                {
                    link: "funding",
                    path: "base.funding.activity",
                    text: "View Funding Activity!"
                },
                {
                    link: "funding_deposit",
                    path: "base.funding.transfer",
                    text: "Make A Deposit!"
                },
                {
                    link: "funding_withdrawal",
                    path: "base.funding.transfer",
                    text: "Withdraw Funds!"
                },
                {
                    link: "financial_profile",
                    path: "base.profile.banks",
                    text: "Update your account!"
                },
                {
                    link: "financial_profile_bank",
                    path: "base.profile.banks",
                    text: "Update your bank account!"
                },
                {
                    link: "services",
                    path: "base.services",
                    text: "Turn On Tax-Loss Harvesting!"
                },
                {
                    link: "documents",
                    path: "base.profile.documents",
                    text: "Download tax docs!"
                },
                {
                    link: "personal",
                    path: "base.profile.contact",
                    text: "Update your profile!"
                },
                {
                    link: "tax_plan",
                    path: "base.plans.info",
                    params: {pslug: "taxplan"},
                    text: "Update your profile!"
                },
                {
                    link: "tax_plan_eligibility",
                    path: "base.plans.info",
                    params: {pslug: "taxplan", '#': "eligibility"},
                    text: "Update your profile!"
                },
                {
                    link: "wiseharvesting_info",
                    path: "base.plans.info.feature",
                    params: {pslug: "taxplan", fslug: "wiseharvesting"},
                    text: "Update your profile!"
                },
                {
                    link: "selective_trading_info",
                    path: "base.plans.info.feature",
                    params: {pslug: "taxplan", fslug: "securityselection"},
                    text: "Update your profile!"
                },
                {
                    link: "ira_conversion_info",
                    path: "base.plans.info.feature",
                    params: {pslug: "taxplan", fslug: "taxpreferredaccount"},
                    text: "Update your profile!"
                },
                {
                    link: "planning",
                    path: "base.planning"
                },
                {
                    link: "completed_surveys",
                    path: "base.profile.planning"
                },
                {
                    link: "survey",
                    path: "base.planning.recommendation"
                },
                {
                    link: "recommendation",
                    path: "base.planning.recommendation"
                },

                {
                    link: "create_milestone",
                    path: "base.milestone-mod.create.steps",
                    text: "Create Milestone!"
                },
                {
                    link: "create_retirement",
                    path: "base.milestone-mod.create.steps",
                    params: {msType: "retirement"},
                    text: "Create Retirement Milestone!"
                },
                {
                    link: "create_rainy_day",
                    path: "base.milestone-mod.create.steps",
                    params: {msType: "rainy_day"},
                    text: "Create Rainy Day Milestone!"
                },
                {
                    link: "create_build_wealth",
                    path: "base.milestone-mod.create.steps",
                    params: {msType: "build_wealth"},
                    text: "Create Build Wealth Milestone!"
                },
                {
                    link: "create_custom",
                    path: "base.milestone-mod.create.steps",
                    params: {msType: "custom"},
                    text: "Create Custom Milestone!"
                },
                {
                    link: "create_new_car",
                    path: "base.milestone-mod.create.steps",
                    params: {msType: "new_car"},
                    text: "Create Custom Milestone!"
                },
                {
                    link: "create_new_home",
                    path: "base.milestone-mod.create.steps",
                    params: {msType: "new_home"},
                    text: "Create Custom Milestone!"
                },
                {
                    link: "milestone_retirement",
                    path: "base.milestone.overview",
                    text: "View Retirement Milestone!"
                },
                {
                    link: "milestone_rainy_day",
                    path: "base.milestone.overview",
                    text: "View Rainy Day Milestone!"
                },
                {
                    link: "milestone_build_wealth",
                    path: "base.milestone.overview",
                    text: "View Build Wealth Milestone!"
                },
                {
                    link: "milestone_new_car",
                    path: "base.milestone.overview",
                    text: "View Build Wealth Milestone!"
                },
                {
                    link: "milestone_new_home",
                    path: "base.milestone.overview",
                    text: "View Build Wealth Milestone!"
                },
                {
                    link: "view_milestone",
                    path: "base.milestone.overview",
                    text: "View Milestone!!"
                },

            ];
            /**
             * Determines the route to link to based on notification link.link
             * @param linkName
             * @param extraParams
             * @returns {Array.<T>}
             */
            notifications.link = function (linkName, extraParams) {
                var link = notifications.linkData.filter(function (value) {
                    return value.link === linkName;
                });
                if (link.length) {
                    link = angular.copy(link[0]);
                    link.params || (link.params = {}); // jshint ignore:line

                    if (['milestone_retirement', 'milestone_rainy_day', 'milestone_build_wealth', 'milestone_new_car', 'milestone_new_home'].indexOf(link.link) > -1) {
                        link.params.msId = notifications.getLinksMilestoneId(link);
                    }

                    if (extraParams) {
                        link.params = angular.extend(link.params, extraParams);
                    }

                    link.fullPath = link.path + "(" + JSON.stringify(link.params) + ")";

                    return link;
                }
            };

            /**
             * Determines the milestone id for a particular milestone type
             */
            notifications.getLinksMilestoneId = function (link) {
                var id = null;
                angular.forEach(User.getMilestones(), function (ms) {
                    if (link.link.includes(ms.type)) {
                        id = ms.id;
                    }
                });
                return id;
            };

            /**
             * Removes a specific id from the notification array
             * @param id
             */
            notifications.remove = function (id) {
                var notice;
                notifications.removing = true;

                notice = notifications.get(id);
                if (notice.type === 'modal') {
                    removeModal();
                } else if (notice.id === id) {
                    removeInline(notice);
                }

                $timeout(function () {
                    notifications.removing = false;
                }, 0);
            };
            /**
             * Remove inline notification and set the index for the next notification to be shown
             * @param notice
             */
            function removeInline(notice) {
                var index;

                if (notice.type === "server") {
                    index = notifications.inline.server.indexOf(notice);
                    if (index>-1) {
                        notifications.inline.server.splice(index, 1);
                    }
                }
                if (notice.type === "manual") {
                    index = notifications.inline.manual.indexOf(notice);
                    if (index>-1) {
                        notifications.inline.manual.splice(index, 1);
                    }
                }

                index = notifications.inline.all.indexOf(notice);
                if (index>-1) {
                    notifications.inline.all.splice(index, 1);
                    if (notifications.currentIndex > index) {
                        notifications.currentIndex--;
                    }

                }
                updateCurrentIndex(notifications.currentIndex);
            }

            /**
             * Remove modal notification and set the next modal notification to be show if it exists
             */
            function removeModal() {
                var index;

                if (notifications.modal) {
                    index = notifications.modalList.indexOf(notifications.modal);
                    notifications.modalList.splice(index, 1);
                    if (notifications.modalList.length) {
                        //set next modal
                        notifications.modal = notifications.modalList[0];
                    } else {
                        notifications.modal = false;
                    }
                }
            }

            notifications.resetView = function(type) {
                notifications.viewedAll = false;
                notifications.currentIndex = 0;
                notifications.prevIndex = -1;
                notifications.inline.all.forEach(function(n) {
                   if (type && n.type !== type) {
                       return;
                   }
                   n.viewed = false;
                });
            };

            /**
             * Will mark a notification as read and remove it from list if flagged
             * @param id
             * @param remove
             */
            notifications.read = function (id, remove) {
                notifications.sending = true;

                // $timeout(function() {
                //     // notifications.remove(id);
                //     notifications.next();
                //     notifications.sending = false;
                // }, 1);
                // return;

                var notice = notifications.get(id);
                notice.viewed = true;
                var uuid = new RegExp('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}');
                if (!uuid.test(id) ) {
                    return $timeout(function() {
                        /* fake wait */
                        /* this way any page changes have a chance to happen before this finishes */
                    }, 100).then(function() {
                        finallyRead();
                    });
                } else {
                    return Request.make("user_notifications_read", {notification_id: id}).then(function (response) {
                    }).catch(function () {
                        //always hide even if the request fails
                    }).finally(function () {
                        finallyRead();
                    });
                }

                function finallyRead() {
                    if (remove) {
                        notifications.remove(id);
                    } else {
                        notifications.next();
                    }
                    notifications.sending = false;
                }
            };

            /**
             * Progresses to next item when viewed singularly
             * When displayed based on "viewed" property, just triggers the end when it gets there
             */
            notifications.next = function() {
                notifications.prevIndex = notifications.currentIndex;

                if (!notifications.inline.all.filter(i => !i.viewed).length) {
                    //if everything is viewed, then set currentIndex to just past the end
                    notifications.currentIndex = notifications.count();
                }

                if (notifications.currentIndex < notifications.count()-1) {
                    notifications.currentIndex++;
                } else {
                    //at the end
                    if (notifications.inline.manual.length) {
                        notifications.resetView('manual');
                    } else {
                        notifications.viewedAll = true;
                        notifications.currentIndex = notifications.count();
                    }
                }
            };
            /**
             * @deprecated
             */
            notifications.prev = function() {
                notifications.prevIndex = notifications.currentIndex;
                if (notifications.currentIndex > 0) {
                    notifications.currentIndex--;
                } else {
                    //at the beginning
                }
            };

            notifications.count = function () {
                return notifications.inline.all.length;
            };

            /**
             * Updates the currentIndex
             *
             * @param index
             */
            function updateCurrentIndex(index) {
                notifications.currentIndex = index;
                if (notifications.currentIndex > notifications.count()-1) {
                    notifications.viewedAll = true;
                    notifications.currentIndex = notifications.count();
                }
            }

            return notifications;
        };

        return notificationBase;

    }]);
})();
